import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useSubscriptions} from '../hooks/useSubscriptions';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useSubscriptions();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
